__turbopack_context__.v({
  "button": "EffektButton-module-scss-module___oeOKq__button",
  "button__squared": "EffektButton-module-scss-module___oeOKq__button__squared",
  "buttonaccent": "EffektButton-module-scss-module___oeOKq__buttonaccent",
  "buttonprimary": "EffektButton-module-scss-module___oeOKq__buttonprimary",
  "buttonsecondary": "EffektButton-module-scss-module___oeOKq__buttonsecondary",
  "buttonsecondary--selected": "EffektButton-module-scss-module___oeOKq__buttonsecondary--selected",
  "buttontertiary": "EffektButton-module-scss-module___oeOKq__buttontertiary",
  "disabledBtn": "EffektButton-module-scss-module___oeOKq__disabledBtn",
  "extraMargin": "EffektButton-module-scss-module___oeOKq__extraMargin",
  "fullWidth": "EffektButton-module-scss-module___oeOKq__fullWidth",
  "noMinWidth": "EffektButton-module-scss-module___oeOKq__noMinWidth",
  "selected": "EffektButton-module-scss-module___oeOKq__selected",
  "useCheckmark": "EffektButton-module-scss-module___oeOKq__useCheckmark",
});
